<h3 mat-dialog-title style="color:#a20000;text-align:center;padding-top:20px;margin-bottom:2px">WARNING</h3>
<mat-dialog-content>
    <div style="color:#a20000;text-align:center;padding-top:5px;" *ngIf="massEmail.Subject == null || massEmail.Subject.length == 0">This email has no subject.</div>
    <div style="color:#a20000;text-align:center;padding-top:5px;" *ngIf="massEmail.Body == null || massEmail.Body.length == 0">This email has no content.</div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class='flex-footer-right'>
        <tyl-button style="float:right;" image="next arrow.png" label="Send Anyway" (clickEvent)="sendAnywayClick()"></tyl-button>
        <tyl-button style="float:right;" image="Cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
    </div>
</mat-dialog-actions>